import { useRentalManagerAccountViewZrmListingsWebApiHandler_options } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';
import type { RentalManagerAccountViewZrmListingsWebApiHandler_options_Options } from '@zg-rentals/ts-rental-manager-api-client-react-query';

export const useGetListingOptions = (
  listingAlias: ListingAlias,
  options: Partial<RentalManagerAccountViewZrmListingsWebApiHandler_options_Options> = {},
) => {
  const { data, error, isFetching } = useRentalManagerAccountViewZrmListingsWebApiHandler_options(
    { listingAlias },
    {
      ...options,
      enabled: Boolean(listingAlias) && (options.enabled ?? true),
      meta: {
        tags: ['getListingOptions', listingAlias],
        context: {
          api: 'useRentalManagerAccountViewZrmListingsWebApiHandler_options',
          details: 'useGetListingOptions',
        },
      },
    },
  );

  return { data, isFetching, error };
};
